<iframe
  #frame
  class="background-animation-frame"
  [class.background-animation-frame--hidden]="!srcdoc"
  aria-hidden="true"
  loading="eager"
  sandbox="allow-scripts"
  tabindex="-1"
  title=""></iframe>
